export function datePicker() {
    $("#datePicker").ejDatePicker({
        highlightWeekend: true,
        allowEdit: false,
        minDate: Date.now()
    });
}
